export default __webpack_public_path__ + "static/media/amun1.412fbdf6.svg";